
import EoIcon from '../EoIcon/EoIcon.vue'
import EoLogo from '../EoLogo/EoLogo.vue'

export default {
  name: 'EoBreadcrumbs',
  components: {
    EoIcon,
    EoLogo,
  },
  props: {
    /**
     * Start crumbs with hyperlink to www.eo.nl
     */
    eoRoot: {
      type: Boolean,
      default: false,
    },
    /**
     * Array of crumbs
     */
    items: {
      type: Array,
      default: null,
    },
    /**
     * Text color of the items
     */
    textColor: {
      type: String,
      default: null,
    },
    /**
     * Text color of the clickable items
     */
    accentColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes () {
      return {
        'eo-breadcrumbs': true,
        ['text--' + this.textColor]: !!this.textColor,
      }
    },
    normalizedItems () {
      if (!this.items) return []
      return this.items.filter(item => item)
    },
  },
  methods: {
    isLastItem (index) {
      return index === this.items?.length - 1
    },
    getLinkTag (item, index) {
      if (item && item.to && !this.isLastItem(index)) {
        if (
          item.to.startsWith('https://') ||
          item.to.startsWith('http://') ||
          item.to.startsWith('tel:') ||
          item.to.startsWith('mailto:') ||
          item.to.startsWith('whatsapp:') ||
          item.to.startsWith('#')
        ) {
          return 'a'
        }
        if (this.$root.$options.components.NuxtLink) {
          return 'nuxt-link'
        } else if (this.$root.$options.components.RouterLink) {
          return 'router-link'
        } else {
          return 'a'
        }
      }
      return 'span'
    },
  },
}
